"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferContractResponseDto = instanceOfOfferContractResponseDto;
exports.OfferContractResponseDtoFromJSON = OfferContractResponseDtoFromJSON;
exports.OfferContractResponseDtoFromJSONTyped = OfferContractResponseDtoFromJSONTyped;
exports.OfferContractResponseDtoToJSON = OfferContractResponseDtoToJSON;
exports.OfferContractResponseDtoToJSONTyped = OfferContractResponseDtoToJSONTyped;
var OfferContractDataDto_1 = require("./OfferContractDataDto");
/**
 * Check if a given object implements the OfferContractResponseDto interface.
 */
function instanceOfOfferContractResponseDto(value) {
    if (!('success' in value) || value['success'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function OfferContractResponseDtoFromJSON(json) {
    return OfferContractResponseDtoFromJSONTyped(json, false);
}
function OfferContractResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'success': json['success'],
        'data': (0, OfferContractDataDto_1.OfferContractDataDtoFromJSON)(json['data']),
        'message': json['message'],
    };
}
function OfferContractResponseDtoToJSON(json) {
    return OfferContractResponseDtoToJSONTyped(json, false);
}
function OfferContractResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'success': value['success'],
        'data': (0, OfferContractDataDto_1.OfferContractDataDtoToJSON)(value['data']),
        'message': value['message'],
    };
}
